export default __webpack_public_path__ + "static/media/diagram-ko-mobile.de8c1ad7.jpg";